import { DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutIntercompanySlideout extends Layout {
    panelIntercompany: Panel;
    sourceEdiMovementOrderIc: DataSource;
    tableIntercompany: Table;
}
